import React from "react";
import { QRCodeCanvas } from "qrcode.react";

const GenerateQRCode = ({ requestId }) => {
  return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
      <QRCodeCanvas value={requestId} size={200} />
    </div>
  );
};

export default GenerateQRCode;
